import axios from "axios";
import { saveReturnTo } from "~/auth/returnTo";
import { currentPath, currentPathname, navigateTo } from "~/utils/navigation";

const api = axios.create({
  baseURL: process.env.REACT_APP_ANTECIPE_URL,
  withCredentials: true,
  headers: { "Content-Type": "application/json;charset=UTF-8" },
});

const isAdminPath = (pathname) => pathname === "/admin" || pathname.startsWith("/admin/");

// Só 401 manda para o login (CA17). 403/409/422 são erros de tela.
export const handleResponseError = (error) => {
  const status = error?.response?.status;
  if (status === 401 && error?.config?.skipAuthRedirect !== true && isAdminPath(currentPathname())) {
    saveReturnTo(currentPath());
    navigateTo("/login");
  }
  return Promise.reject(error);
};

api.interceptors.response.use((response) => response, handleResponseError);

export default api;
